import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { CalendarIntegrationPayload } from 'athena/components/mentoring-program/home/participant/session-edit-mode/utils';
import moment from 'moment';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { getCalendarIntegrationSettings } from 'redux/selectors/mentorship-program-sessions';

export type CalendarIntegrationSettings = {
  hasMs365CalendarIntegration: boolean;
  isAuthenticated: boolean;
  needsReauthentication: boolean;
  isCalendarIntegrationMissing: boolean;
  isOnlyCalendarIntegration: boolean;
  isOnlyCalendarIntegrationEnabled: boolean;
  calendarIntegrationSettings: CalendarIntegrationPayload;
};

const useCalendarIntegration = (source?: string[]): CalendarIntegrationSettings => {
  const currentInstitution = useSelector(getCurrentInstitution);
  const hasMs365CalendarIntegration = currentInstitution?.hasMs365CalendarIntegration || false;

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id: programId, mentorshipProgramEnrollment: enrollmentId } = mentoringProgram || {};

  const calendarIntegrationSettings = useSelector(getCalendarIntegrationSettings(programId, enrollmentId));
  const isAuthenticated = moment().isBefore(moment(calendarIntegrationSettings?.expiresAt));
  const needsReauthentication = moment().isAfter(moment(calendarIntegrationSettings?.expiresAt));
  const isCalendarIntegrationMissing = hasMs365CalendarIntegration && (
    !calendarIntegrationSettings || needsReauthentication
  );
  const isOnlyCalendarIntegration = source ? (
    source?.length === 0 && hasMs365CalendarIntegration && isCalendarIntegrationMissing
  ) : false;
  const isOnlyCalendarIntegrationEnabled = hasMs365CalendarIntegration && (
    !source || source?.length === 0
  );

  return {
    hasMs365CalendarIntegration,
    isAuthenticated,
    needsReauthentication,
    isCalendarIntegrationMissing,
    isOnlyCalendarIntegration,
    isOnlyCalendarIntegrationEnabled,
    calendarIntegrationSettings,
  };
};

export default useCalendarIntegration;
